// WHY: спрайты в public/ со стабильными URL кэшируются far-future — редеплой кэш не сбросит; при смене ассетов бампить
// версию
export const BATTLE_ASSET_VERSION = '5';

export const bustCache = (src: string): string =>
  src.includes('?') ? src : `${src}?v=${BATTLE_ASSET_VERSION}`;
